import { IcdCorporationManager, IcdCorporationManagerRM } from "@herbjoy/apex-api-models";
import { IHttpService } from "angular";

export class RegionalConsultantService {
    constructor(private $http: IHttpService, private apexApiUrl: string) {
        'ngInject';
    }

    retrieveRegionalConsultants() {
        return this.$http<IcdCorporationManagerRM[]>({
            method: "GET",
            url: this.apexApiUrl + "regional-consultants"
        })
            .then(function (response) {
                return response.data;
            });
    }

    retrieveRegionalConsultant(regionalConsultantID: number) {
        return this.$http<IcdCorporationManagerRM>({
            method: "GET",
            url: this.apexApiUrl + "regional-consultants/" + regionalConsultantID
        })
            .then(function (response) {
                return response.data;
            });
    }

    saveRegionalConsultant(regionalConsultant: IcdCorporationManager) {
        if (regionalConsultant.Id) {
            return this.$http<IcdCorporationManagerRM>({
                method: "PUT",
                url: this.apexApiUrl + "regional-consultants/" + regionalConsultant.Id,
                data: JSON.stringify(regionalConsultant),
                headers: { "Content-Type": "application/json" }
            })
                .then(function () {
                    return regionalConsultant;
                });
        } else {
            return this.$http<IcdCorporationManagerRM>({
                method: "POST",
                url: this.apexApiUrl + "regional-consultants",
                data: JSON.stringify(regionalConsultant),
                headers: { "Content-Type": "application/json" }
            })
                .then(function (response) {
                    return response.data;
                });
        }
    }

    deleteRegionalConsultant(regionalConsultantID: number) {
        return this.$http<IcdCorporationManagerRM>({
            method: "DELETE",
            url: this.apexApiUrl + "regional-consultants/" + regionalConsultantID,
            headers: {
                "Content-Type": "application/json"
            },
            data: {}
        });
    }
}
